import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
    Nav,
    NavItem,
    NavLink,
    Badge,
    TabContent,
    TabPane,
    ListGroup,
    ListGroupItem,
    Button,
} from "reactstrap";
import {
    fetchOrders,
    fetchTodayOrders,
    removeProvider,
    confirmOrder,
} from "../../store/actions/orderActions";
import {
    markNotificationConsumed,
    setNotificationsListEmpty,
    fetchNewNotifications,
} from "../../store/actions/notificationsActions";
import { isPickUp } from "../../store/actions/UtilsOperation";
import {
    pendingActions,
    deletePendingAction,
    confirmPendingAction,
} from "../../store/actions/companyActions";
import ModalBase from "../../views/Plugins/MainModals/ModalBase";
import NewModalBase from "../../views/Plugins/MainModals/NewModalBase";
import NewModalConfirm from "../../views/Plugins/MainModals/NewModalConfirm";
import ModalOrder from "../../views/Orders/modalOrder";
import ModalAssignProvider from "../../views/Orders/modalAssignProvider";
import PendingAccionProvider from "../../views/Provider/pendingAccionProvider";
import {
    /*BRANCH_ACCESS,
	BRANCH_GROUPS_ACCESS,*/
    COMPANY_ACCESS,
} from "../../constants/general";
import permissions from "../../utils/permissions";

const defaultProps = {};

class DefaultAside extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.myAudio = new Audio(
            window.location.origin + "/assets/notification.mp3"
        );
        this.myAudio.preload = true;

        this.state = {
            activeTab: "1",
        };
        this.props.fetchTodayOrders();
        //this.props.pendingActions();
        this.props.fetchNewNotifications();
    }
    componentWillReceiveProps(prevProps) {
        if (
            (prevProps && prevProps.branch && prevProps.branch.id) !==
            (this.props.branch && this.props.branch.id)
        ) {
            this.props.fetchTodayOrders();
        }
    }
    unassignProvider(order_id, provider_id) {
        this.props.removeProvider(order_id, provider_id);
        //if(this.props.history.location === "/map") /* TODO: actualizar solo en el mapa (quizas en la tabla ordenes) para que se vea el cambio */
        //this.props.fetchOrders();
    }

    listNotifications() {
        return (
            this.props.notifications &&
            this.props.notifications.length > 0 &&
            this.props.notifications.map((noti, key) => {
                let notiTitle = <b>{noti.title || ""}</b>;
                let microcopy =
                    this.props.json_lang.default_aside
                        .mark_notification_consumed;
                let noti_id = noti.id || key;
                let isPush = noti.id ? false : true;

                {
                    /*if(noti.consumed){
				notiTitle = noti.title;
				microcopy = '';
			}*/
                }

                return (
                    <ListGroupItem
                        key={key}
                        action
                        tag="li"
                        className="list-group-item-divider d-flex flex-row notifications-list"
                    >
                        <Link
                            to={noti.url || ""}
                            className="unsetlink flex-fill"
                            onClick={(e) =>
                                noti.consumed
                                    ? undefined
                                    : this.props.markNotificationConsumed(
                                          noti_id,
                                          isPush
                                      )
                            }
                        >
                            <span
                                style={{
                                    width: "calc(100% - 25px)",
                                    display: "inline-block",
                                }}
                            >
                                {notiTitle || ""}
                                {noti.msg ? (
                                    <small className="text-muted btn-block">
                                        {noti.msg || ""}
                                    </small>
                                ) : null}
                            </span>
                            <span
                                id={key}
                                className="flex-fill align-self-stretch close"
                                aria-label="Close"
                                title={microcopy || ""}
                            >
                                <i
                                    aria-hidden="true"
                                    className={`fa ${
                                        noti.consumed
                                            ? `fa-circle-o`
                                            : `fa-circle`
                                    }`}
                                ></i>
                            </span>
                        </Link>
                    </ListGroupItem>
                );
            })
        );
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            if (this.state.activeTab === "1") {
                this.props.fetchNewNotifications();
            }

            if (this.state.activeTab === "1") {
                this.props.pendingActions();
            }

            this.setState({
                activeTab: tab,
            });
        }
    }

    open_modal_data = (id, modal, name) => {
        this.setState({
            selectedId: id,
            selectedName: name,
        });
        this.refs[modal].toggleModal();
    };

    render() {
        // Permiso granular "Órdenes (solo visualización)" (access_orders-readonly): oculta las
        // acciones de asignar/desasignar/confirmar en el sidebar "Órdenes de hoy".
        const canManageOrders = permissions.canManageOrders(this.props.session);

        return (
            <React.Fragment>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            title={
                                this.props.json_lang.default_aside
                                    .aside_menu_title
                            }
                            onClick={() => {
                                this.toggle("1");
                            }}
                            className={
                                this.state.activeTab === "1" ? "active" : ""
                            }
                        >
                            <i className="icon-bell"></i>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            onClick={() => {
                                this.toggle("2");
                            }}
                            className={
                                this.state.activeTab === "2" ? "active" : ""
                            }
                        >
                            <i className="icon-bag"></i>
                        </NavLink>
                    </NavItem>
                    {this.props.userHigherAccess === COMPANY_ACCESS ? (
                        <NavItem>
                            <NavLink
                                onClick={() => {
                                    this.toggle("3");
                                }}
                                className={
                                    this.state.activeTab === "3" ? "active" : ""
                                }
                            >
                                <i className="fa fa-motorcycle"></i>
                            </NavLink>
                        </NavItem>
                    ) : null}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                        <ListGroup className="list-group-accent">
                            <ListGroupItem
                                className="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small"
                                style={{ fontSize: "14px" }}
                            >
                                <h6
                                    style={{
                                        display: "inline-block",
                                        float: "left",
                                    }}
                                    className="mr-2 mb-0"
                                >
                                    {this.props.notificationsCounter ? ( // TODO: falta restarle si el usuario lee una notificacion y un endpoint para traer los que falta por leer
                                        <Badge
                                            color="warning"
                                            size="md"
                                            className="ml-1 badge-pill"
                                        >
                                            {this.props.notificationsCounter}
                                        </Badge>
                                    ) : null}
                                </h6>
                                {
                                    this.props.json_lang.default_aside
                                        .aside_notifications_title
                                }

                                <Link
                                    color="secondary"
                                    title="Configurar Notificaciones"
                                    to={`/profile/${this.props.session.id}`}
                                >
                                    <i
                                        style={{
                                            fontWeight: "bolder",
                                            fontSize: "1.2em",
                                            display: "inline-block",
                                            float: "right",
                                        }}
                                        className="fa fa-cog mr-1 mb-0"
                                    />
                                </Link>
                            </ListGroupItem>

                            {this.listNotifications()}
                            {this.props.notifications &&
                            this.props.notifications.length > 4 ? (
                                <ListGroupItem className="list-group-item-divider d-flex flex-row notifications-list text-center">
                                    <Link
                                        color="info"
                                        to={"/notifications"}
                                        style={{ width: "100%" }}
                                    >
                                        <b>
                                            {
                                                this.props.json_lang.common
                                                    .see_all
                                            }
                                        </b>
                                    </Link>
                                </ListGroupItem>
                            ) : null}
                        </ListGroup>
                    </TabPane>
                    <TabPane tabId="2">
                        <ListGroup className="list-group-accent">
                            <ListGroupItem
                                style={{ fontSize: "14px" }}
                                className="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small"
                            >
                                <h6
                                    style={{
                                        display: "inline-block",
                                        float: "left",
                                    }}
                                    className="mr-2 mb-0"
                                >
                                    {/*
										this.props.ordersCounter && this.props.ordersCounter.unassigned > 0?
											<Badge color="danger" size="md" title={this.props.json_lang.default_aside.unassgined_badge_tooltip} className="ml-1 badge-pill">
												{this.props.ordersCounter.unassigned}
											</Badge>
										:null
									}

									{
										this.props.ordersCounter && this.props.ordersCounter.assigned > 0?
											<Badge color="success" size="md" title={this.props.json_lang.default_aside.assgined_badge_tooltip} className="ml-1 badge-pill">
												{this.props.ordersCounter.assigned}
											</Badge>
										:null
									*/}
                                </h6>
                                {
                                    this.props.json_lang.default_aside
                                        .aside_menu_title
                                }
                            </ListGroupItem>
                            {this.props.todayOrders
                                ? this.props.todayOrders.map((order, key) => {
                                      let providerText = this.props.json_lang.default_aside.provider_unassigned_msg;
                                      if(order.is_shopper_allowed && !order.is_shopper_assigned){
                                        providerText = this.props.json_lang.default_aside.shopper_unassigned_msg;
                                      }
                                      var action =
                                          "list-group-item-accent-danger";
                                      var provider = canManageOrders ? (
                                          <Fragment>
                                              <Button
                                                  color="link"
                                                  className={
                                                      "text-danger btn-block text-left p-0"
                                                  }
                                                  onClick={(e) => {
                                                      e.stopPropagation();
                                                      e.preventDefault();
                                                      this.refs[
                                                          `order-assing-` + key
                                                      ].toggleModal();
                                                  }}
                                              >
                                                  {
                                                    providerText
                                                  }
                                                  <br />
                                              </Button>
                                          </Fragment>
                                      ) : (
                                          <span className="text-danger">
                                              {providerText}
                                              <br />
                                          </span>
                                      );

                                      if (
                                          isPickUp(
                                              order.client_latitude_e6,
                                              order.client_longitude_e6,
                                              order.client_address
                                          )
                                      ) {
                                          provider = null;
                                      }
                                      //console.log("order.order_providers",order.providers[0])
                                      if (
                                          order &&
                                          order.providers &&
                                          order.providers[0] &&
                                          (order.is_shopper_allowed && !order.is_status_prepared ?
                                            order.is_shopper_assigned :
                                            order.is_provider_assigned
                                          )
                                      ) {
                                          action =
                                              "list-group-item-accent-success";
                                          provider = (
                                              <Fragment>
                                                  <div className="py-3 mr-3 float-left">
                                                      <img
                                                          className="avatar_small"
                                                          src={
                                                              order.providers[0]
                                                                  .avatar_url
                                                                  ? order
                                                                        .providers[0]
                                                                        .avatar_url
                                                                  : "https://api-dev.dondemand.io/storage/static/default/avatar_rider-48x48.jpg"
                                                          }
                                                          alt={
                                                              order
                                                                  .providers[0] &&
                                                              order.providers[0]
                                                                  .email
                                                                  ? order
                                                                        .providers[0]
                                                                        .email
                                                                  : ""
                                                          }
                                                      />
                                                      <span className="avatar-status badge-success"></span>
                                                  </div>

                                                  <div>
                                                    {
                                                        order.is_shopper_allowed && !order.is_provider_assigned ?
                                                            this.props.json_lang
                                                            .default_aside
                                                            .shopper_assigned_msg
                                                        :
                                                            this.props.json_lang
                                                                .default_aside
                                                                .provider_assigned_msg
                                                    }



                                                      <br />
                                                      <strong>
                                                          {order.providers[0]
                                                              .name
                                                              ? order
                                                                    .providers[0]
                                                                    .name
                                                              : ""}{" "}
                                                      </strong>
                                                  </div>
                                              </Fragment>
                                          );
                                      }

                                      return (
                                          <ListGroupItem
                                              key={key}
                                              action
                                              tag="span"
                                              className={
                                                  `list-group-item-divider ` +
                                                  action
                                              }
                                          >
                                              <div
                                                  onClick={() =>
                                                      this.refs[
                                                          `details` + key
                                                      ].toggleModal()
                                                  }
                                                  className="clearfix"
                                              >
                                                  <small>
                                                      <b>
                                                          {
                                                              this.props
                                                                  .json_lang
                                                                  .common
                                                                  .order_number_msg
                                                          }
                                                      </b>
                                                      {order.uid
                                                          ? order.uid
                                                          : this.props.json_lang
                                                                .order_status
                                                                .unconfirmed}
                                                  </small>
                                                  {order.provider && canManageOrders ? (
                                                      <Button
                                                          color="ghost-danger"
                                                          className="btn-sm float-right"
                                                          onClick={NewModalConfirm.open(
                                                              `unAssing-` + key
                                                          )}
                                                      >
                                                          <i className="icon-user-unfollow"></i>
                                                      </Button>
                                                  ) : null}

                                                  {provider}

                                                  <small className="text-muted">
                                                      {isPickUp(
                                                          order.client_latitude_e6,
                                                          order.client_longitude_e6,
                                                          order.client_address
                                                      ) ? (
                                                          this.props.json_lang
                                                              .common.pickup
                                                      ) : (
                                                          <Fragment>
                                                              {order.client_address ? (
                                                                  <Fragment>
                                                                      <i className="icon-location-pin"></i>
                                                                      {
                                                                          order.client_address
                                                                      }
                                                                  </Fragment>
                                                              ) : null}
                                                          </Fragment>
                                                      )}
                                                  </small>
                                              </div>
                                              <NewModalConfirm
                                                  id={`unAssing-` + key}
                                                  confirmFunc={() =>
                                                      this.unassignProvider(
                                                          order.id,
                                                          order.provider.id
                                                      )
                                                  }
                                                  html={
                                                      <p className="text-center mb-0">
                                                          {
                                                              this.props
                                                                  .json_lang
                                                                  .default_aside
                                                                  .confirm_unassign_modal_1
                                                          }
                                                          <b className="text-danger">
                                                              {
                                                                  this.props
                                                                      .json_lang
                                                                      .table_orders
                                                                      .unassing
                                                              }
                                                          </b>{" "}
                                                          {
                                                              this.props
                                                                  .json_lang
                                                                  .default_aside
                                                                  .confirm_unassign_modal_2
                                                          }{" "}
                                                      </p>
                                                  }
                                              />

                                              {order.uid ? (
                                                  <ModalBase
                                                      ref={`details` + key}
                                                      title={`${
                                                          this.props.json_lang
                                                              .default_aside
                                                              .modal_order_title
                                                      } #${
                                                          order.uid
                                                              ? order.uid
                                                              : this.props
                                                                    .json_lang
                                                                    .order_status
                                                                    .unconfirmed
                                                      }`}
                                                      reference={() =>
                                                          this.open_modal_data(
                                                              0,
                                                              `details` + key`,`
                                                          )
                                                      }
                                                      html={
                                                          <ModalOrder
                                                              orderID={order.id}
                                                          />
                                                      }
                                                  />
                                              ) : (
                                                  <ModalBase
                                                      ref={`details` + key}
                                                      confirmFunc={
                                                          canManageOrders
                                                              ? () =>
                                                                    this.props.confirmOrder(
                                                                        order.id
                                                                    )
                                                              : undefined
                                                      }
                                                      reference={() =>
                                                          this.open_modal_data(
                                                              0,
                                                              `details` + key`,`
                                                          )
                                                      }
                                                      title={`${
                                                          this.props.json_lang
                                                              .default_aside
                                                              .modal_order_title
                                                      } #${
                                                          order.uid
                                                              ? order.uid
                                                              : this.props
                                                                    .json_lang
                                                                    .order_status
                                                                    .unconfirmed
                                                      }`}
                                                      html={
                                                          <ModalOrder
                                                              orderID={order.id}
                                                          />
                                                      }
                                                  />
                                              )}
                                              <ModalBase
                                                  ref={`order-assing-` + key}
                                                  id={`order-assing-` + key}
                                                  title={
                                                      this.props.json_lang
                                                          .map_view
                                                          .provider_list_modal_title
                                                  }
                                                  html={
                                                      <ModalAssignProvider
                                                          orderID={order.id}
                                                          reference={() => {
                                                                this.props.fetchTodayOrders();
                                                                this.props.fetchOrders();
                                                                this.open_modal_data(
                                                                    0,
                                                                    `order-assing-` + key,
                                                                    //`providerAssingOrder`
                                                                )
														    }
                                                          }
                                                      />
                                                  }
                                              />
                                          </ListGroupItem>
                                      );
                                  })
                                : null}
                        </ListGroup>
                    </TabPane>
                    {this.props.userHigherAccess === COMPANY_ACCESS ? (
                        <TabPane tabId="3">
                            <ListGroup className="list-group-accent">
                                <ListGroupItem
                                    className="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small"
                                    style={{ fontSize: "14px" }}
                                >
                                    {
                                        this.props.json_lang.default_aside
                                            .pending_changes
                                    }
                                </ListGroupItem>
                                {this.props.actions &&
                                this.props.actions &&
                                this.props.actions.length > 0 ? (
                                    this.props.actions.map((action, key) => {
                                        var actionItem;
                                        if (
                                            action &&
                                            action.type === 1 &&
                                            action.data &&
                                            action.data.provider
                                        ) {
                                            actionItem = (
                                                <ListGroupItem
                                                    key={key}
                                                    action
                                                    tag="span"
                                                    className={`list-group-item-divider d-flex flex-row`}
                                                >
                                                    <div
                                                        className="clearfix"
                                                        style={{
                                                            width: "calc(100% - 25px)",
                                                        }}
                                                        onClick={() =>
                                                            this.refs[
                                                                `pendingActions-` +
                                                                    key
                                                            ].toggleModal()
                                                        }
                                                    >
                                                        <div className="mr-3 float-left">
                                                            <img
                                                                id={`avatar_small-${action.data.provider.id}`}
                                                                onError={() =>
                                                                    (document.getElementById(
                                                                        `avatar_small-${action.data.provider.id}`
                                                                    ).src =
                                                                        "https://api-dev.dondemand.io/storage/static/default/avatar_rider-48x48.jpg")
                                                                }
                                                                className="avatar_small"
                                                                src={
                                                                    action.data
                                                                        .provider
                                                                        .avatar_url
                                                                        ? action
                                                                              .data
                                                                              .provider
                                                                              .avatar_url
                                                                        : "https://api-dev.dondemand.io/storage/static/default/avatar_rider-48x48.jpg"
                                                                }
                                                                alt={
                                                                    action.data
                                                                        .provider
                                                                        .email
                                                                        ? action
                                                                              .data
                                                                              .provider
                                                                              .email
                                                                        : ""
                                                                }
                                                            />
                                                            <span className="avatar-status badge-success"></span>
                                                        </div>

                                                        <b>
                                                            {
                                                                action.data
                                                                    .provider
                                                                    .name
                                                            }
                                                        </b>
                                                        <small className="text-muted btn-block">
                                                            Ha hecho
                                                            modificaciones que
                                                            debes aprobar
                                                        </small>
                                                    </div>
                                                    <Button
                                                        color="ghost-danger"
                                                        className="btn-sm float-right"
                                                        onClick={NewModalConfirm.open(
                                                            `deleteAction-` +
                                                                key
                                                        )}
                                                    >
                                                        <span aria-hidden="true">
                                                            &times;
                                                        </span>
                                                    </Button>
                                                    <ModalBase
                                                        ref={
                                                            `pendingActions-` +
                                                            key
                                                        }
                                                        title={`Actualización proveedor`}
                                                        html={
                                                            <PendingAccionProvider
                                                                data={action.data}
                                                                refuse={() => this.props.deletePendingAction(action.id)}
                                                                confirm={() => this.props.confirmPendingAction(action.id)}
                                                            />
                                                        }
                                                    />
                                                    <NewModalConfirm
                                                        id={
                                                            `deleteAction-` +
                                                            key
                                                        }
                                                        confirmFunc={() =>
                                                            this.props.deletePendingAction(
                                                                action.id
                                                            )
                                                        }
                                                        html={
                                                            "¿Está seguro de que desea cancelar esta acción?"
                                                        }
                                                    />
                                                </ListGroupItem>
                                            );
                                        }
                                        return actionItem;
                                    })
                                ) : (
                                    <ListGroupItem>
                                        {
                                            this.props.json_lang.default_aside
                                                .no_pendings_msg
                                        }
                                    </ListGroupItem>
                                )}
                            </ListGroup>
                        </TabPane>
                    ) : null}
                </TabContent>
            </React.Fragment>
        );
    }
}

DefaultAside.defaultProps = defaultProps;

const mapStateToProps = (state) => {
    return {
        session: state.session,
        notifications: state.notifications, //(state.notifications && state.notifications.slice(0, 8)) || [],
        todayOrders: state.todayOrders,
        branch: state.branch,
        ordersCounter: state.ordersCounter,
        notificationsCounter: state.notificationsCounter,
        json_lang: state.json_lang,
        //localUserSettings: state.localUserSettings,
        actions: state.pendingActions,
        userHigherAccess: state.userHigherAccess,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        fetchTodayOrders: () => dispatch(fetchTodayOrders()),
        fetchOrders: () => dispatch(fetchOrders()),
        fetchNewNotifications: (page) => dispatch(fetchNewNotifications(page)),
        //changeLocalUserSettings: (settings, value, data) => dispatch(changeLocalUserSettings(settings, value, data)),
        markNotificationConsumed: (id, isPush) =>
            dispatch(markNotificationConsumed(id, isPush)),
        removeProvider: (id, provider) =>
            dispatch(removeProvider(id, provider)),
        confirmOrder: (id) => dispatch(confirmOrder(id)),
        setNotificationsListEmpty: () => dispatch(setNotificationsListEmpty()),
        pendingActions: () => dispatch(pendingActions()),
        deletePendingAction: (id) => dispatch(deletePendingAction(id)),
        confirmPendingAction: (id) => dispatch(confirmPendingAction(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultAside);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultAside.js